import { useParams } from "react-router-dom";
import TopSideBar from "../../components/TopSideBar";
import UserPasswordReset from "../../components/UserPasswordReset";
import PageContainer from "../../components/common/PageContainer";
import Copyright from "../../components/common/Copyright";

export default function UserPasswordResetPage({ setBlockScreen }: any) {
  const params = useParams<{ token?: string }>()
  const token = params.token ?? ''

  return (<>
    <TopSideBar currentSection="" hideMenu hideUser hideProjectSelector />
    <PageContainer>
      <UserPasswordReset token={token} setBlockScreen={setBlockScreen} />
      <Copyright />
    </PageContainer>
  </>)
}